/**
 * Presentation-layer glossary. Maps legacy product names that arrive from the
 * API (or live in shared enums) to the Prezynt display names. Applies to labels
 * only; the underlying ids, enum values and API fields never change.
 */
const REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bGyftPro\b/g, "Prezynt"],
  [/\bGyftpro\b/g, "Prezynt"],
  [/\bGenie\b/g, "Mira"],
  [/\bMuse\b/g, "Mira"],
  [/\bGyftCoins?\b/g, "Sparks"],
  [/\bGyftcoins?\b/g, "Sparks"],
  [/\bgyftcoins?\b/g, "Sparks"],
  [/\bDiscovery Swipe\b/g, "Discovery"],
  [/\bDiscover\b/g, "Discovery"],
  [/\bCo-Gyfting\b/gi, "Co-Gifting"],
  [/\bCo-Gyfters?\b/gi, "Co-Gifting"],
  [/\bGyfts? for Me\b/gi, "My Wishlist"],
  [/\bGyfted\b/g, "Gifted"],
];

export const toDisplayLabel = (label: string): string =>
  REPLACEMENTS.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), label);
